export default __webpack_public_path__ + "static/media/Poppins-ExtraBoldItalic.73d4495b.ttf";